import React from "react";
import {PersonGenomeBasic} from "../../../services/interface/query/person";
import {getAgeOfDate} from "../../../utils/daysOptions";
import IdentificationConsult from "../../terms-conditions/IdentificationConsult";
import {RiPhoneFill} from "react-icons/ri";
import {usePersonPosition} from "./usePersonPosition";
import {formatGenomeName} from "./formatGenomeName";

interface Props {
    classNameContainer?: string;
    relationship?: string;
    person?: PersonGenomeBasic | null;
    personRefList: any[];
    setPersonRefList: React.Dispatch<React.SetStateAction<any[]>>;
    containerRef: React.RefObject<HTMLDivElement>;
    genomeRef: React.RefObject<HTMLDivElement>;
    width?: string;
    style?: any;
    setValue?: React.Dispatch<React.SetStateAction<number>>;
}

const PersonGenome = ({
                          classNameContainer,
                          relationship,
                          person,
                          personRefList,
                          setPersonRefList,
                          containerRef,
                          genomeRef,
                          width,
                          style,
                          setValue
                      }: Props) => {
    const {personGenomeRef, updateView} = usePersonPosition({
        person, relationship, personRefList, setPersonRefList, containerRef, genomeRef, width,
    });

    if (person === undefined) {
        return null;
    }

    return (
        <div ref={personGenomeRef}
             onMouseEnter={() => {updateView(true)}}
             onMouseLeave={() => {updateView(false)}}
             className={`${classNameContainer} bg-grayCard flex flex-col
             rounded-[5px] p-0 w-[150px] min-w-[150px] max-w-[150px] max-h-[80px] hover:z-20 !border-[2px]
             border-transparent hover:!border-[2px] hover:!border-empColorPrimary`}>
            <span className={`${style?.color} px-2 py-1 rounded-t-[4px] text-[10px] font-bold`}>{relationship}</span>
            <div className={'px-2 py-[6px]'}>
                <div className={'flex flex-row'}>
                    <IdentificationConsult
                        className={'text-header text-[10px] max-w-[80px]'}
                        identification={person?.identification}
                        {...{setValue}}
                    />
                    <span className={'ml-auto text-header text-[10px] font-light'}>
                        {`(${getAgeOfDate(person?.dateOfBirth)})`}
                    </span>
                </div>
                <span className={'flex text-header font-light text-[10px] truncate'}>
                    {formatGenomeName(person?.names)}
                </span>
                <div className={'flex flex-row gap-1 text-header font-light text-[10px] items-center'}>
                    <RiPhoneFill/>
                    {person?.phone ?? '-'}
                </div>
            </div>
        </div>
    );
}

export default PersonGenome
